import { useEffect } from "react"; 
import { initialize, pageview } from "react-ga";
import { useLocation } from "react-router-dom";
import { GA_TRACKING_CODES_BY_HOST } from "../constants/AppConstants";

const hostname = window.location.hostname ?? "";
const host = hostname.split(".")[0];
initialize(GA_TRACKING_CODES_BY_HOST[host] ?? GA_TRACKING_CODES_BY_HOST.dev, {
  testMode: process.env.NODE_ENV !== "production",
  debug: false
});

function GAListener() {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

export default GAListener;
